(function () {
  document.addEventListener('click', function (event) {
    var link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;

    var href = link.getAttribute('href') || '';

    if (/^tel:/i.test(href)) {
      publish('call_button_clicked', {
        button_phone: decodeURIComponent(href.replace(/^tel:/i, '')),
      });
      return;
    }

    if (/^mailto:/i.test(href)) {
      publish('email_button_clicked', {
        email: decodeURIComponent(href.replace(/^mailto:/i, '').split('?')[0]),
      });
    }
  });

  function publish(eventName, payload) {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, payload);
    }
  }
})();
